'use client';

import React__default from 'react';
import { ProficiencyItem, ListProficiency } from './ProficiencyBar.css.js';

var ProficiencyBar = function (props) {
    var totalCol = props.totalCol, value = props.value, background = props.background, borderRadius = props.borderRadius, borderRight = props.borderRight, backgroundSeparator = props.backgroundSeparator;
    if (totalCol === 0)
        return null;
    var listProficiency = [];
    for (var i = 1; i <= totalCol; i++) {
        listProficiency.push(React__default.createElement(ProficiencyItem, { style: {
                width: "".concat(100 / totalCol, "%"),
                borderRight: i === totalCol ? 'none' : borderRight,
                borderBottomLeftRadius: i === 1 ? borderRadius : 'unset',
                borderTopLeftRadius: i === 1 ? borderRadius : 'unset',
                borderBottomRightRadius: i === totalCol ? borderRadius : 'unset',
                borderTopRightRadius: i === totalCol ? borderRadius : 'unset',
            }, key: i, background: i <= value ? backgroundSeparator : background }));
    }
    return (React__default.createElement(ListProficiency, null, listProficiency));
};

export { ProficiencyBar as default };
//# sourceMappingURL=ProficiencyBar.js.map
